var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        visible: _vm.dialogVisible,
        width: "800px",
        title: "新增",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        top: "5vh",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              staticStyle: { "max-width": "800px" },
              attrs: {
                model: _vm.form,
                "label-width": "auto",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "MARK", prop: "mark" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.mark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "mark", $$v)
                              },
                              expression: "form.mark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "英文品名", prop: "nameEN" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.nameEN,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "nameEN", $$v)
                              },
                              expression: "form.nameEN",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "中文品名", prop: "nameCH" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.form.nameCH,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "nameCH", $$v)
                                },
                                expression: "form.nameCH",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _c("i", {
                                  staticClass: "el-input__icon el-icon-search",
                                  attrs: { slot: "suffix" },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogVisible1 = true
                                    },
                                  },
                                  slot: "suffix",
                                }),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "HSCODE", prop: "hsCode" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.form.hsCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "hsCode", $$v)
                                },
                                expression: "form.hsCode",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _c("i", {
                                  staticClass: "el-input__icon el-icon-search",
                                  attrs: { slot: "suffix" },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogVisible2 = true
                                    },
                                  },
                                  slot: "suffix",
                                }),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "产品材质", prop: "material" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.material,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "material", $$v)
                              },
                              expression: "form.material",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "产品用途", prop: "usedFor" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.usedFor,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "usedFor", $$v)
                              },
                              expression: "form.usedFor",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "箱数", prop: "packages" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 1, "controls-position": "right" },
                            model: {
                              value: _vm.form.packages,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "packages", $$v)
                              },
                              expression: "form.packages",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "产品个数", prop: "qty" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 1, "controls-position": "right" },
                            model: {
                              value: _vm.form.qty,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "qty", $$v)
                              },
                              expression: "form.qty",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "产品单价", prop: "unitPrice" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 0.01,
                              precision: 2,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.form.unitPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "unitPrice", $$v)
                              },
                              expression: "form.unitPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "产品净重", prop: "netWeight" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 0.01,
                              precision: 2,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.form.netWeight,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "netWeight", $$v)
                              },
                              expression: "form.netWeight",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "产品毛重", prop: "grossWeight" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 0.01,
                              precision: 2,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.form.grossWeight,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "grossWeight", $$v)
                              },
                              expression: "form.grossWeight",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c("div", { staticClass: "footer" }, [
          _c("div", { staticClass: "cancel", on: { click: _vm.cancel } }, [
            _vm._v("取消"),
          ]),
          _c("div", { staticClass: "ok", on: { click: _vm.ok } }, [
            _vm._v("确认"),
          ]),
        ]),
      ]),
      _c("ProductDialog", {
        attrs: { dialogVisible: _vm.dialogVisible1 },
        on: {
          ok: _vm.productOk,
          cancel: function ($event) {
            _vm.dialogVisible1 = false
          },
        },
      }),
      _c("TaxDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2 },
        on: {
          ok: _vm.taxOk,
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }